import React from 'react';
import { Toast, Modal, WhiteSpace } from 'antd-mobile';
import { getShareUrl } from "../../services/global";
import { connect } from "react-redux";
import '@/style/checkin.less';
import Iconfont from "../../components/Iconfont/Iconfont";
import QRCode from "../../components/qr-code/QRCode";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import '@/style/shareqrcodemodal.less';
import defaultcover from "../../style/imgs/invitation-page/default.png";
import moment from 'moment';


class ShareQrcodeModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,

        }
    }

    componentDidMount() {


    }

    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }



    render() {
        const { evt, loginByOauth } = this.props;
        console.log(loginByOauth)




        return (
            <div>
                <Modal
                    className='vr-modal'
                    wrapClassName='sq-modal'
                    visible={this.state.visible}
                    transparent
                    maskClosable={true}
                    onClose={() => this.setState({ visible: false })}

                >
                    <div className='shareposter-container'>
                        {
                            loginByOauth.data &&
                            <div className='sp-title'>
                                <img src={loginByOauth.data.principal.avatarUrl} alt="" />
                                <div>
                                    <span>{loginByOauth.data.principal.nickName}</span>
                                    <p>邀请您一起，快来报名吧~</p>
                                </div>
                            </div>}
                        <img className='sp-banner' src={evt.data.header.banner ? evt.data.header.banner : defaultcover} alt="" />
                        <div className='sp-name'>{evt.data.header.name}</div>
                        <div className='sp-time'>
                            <Iconfont libname="ckicon" type="shijian" /> 报名时间：{moment(evt.data.header.registerBeginTime).format("MM-DD HH:mm")} ~ {moment(evt.data.header.registerEndTime).format("MM-DD HH:mm")}       
                        </div>
                        <QRCode
                            value={getShareUrl()}
                            size={100}
                            refName="register-qr-canvas"
                            logoWidth={20}
                            logoHeight={20}
                        // logo={Logo2}
                        />
                    </div>

                </Modal>
                <Modal
                    // className='signup-modal'
                    popup
                    visible={true}
                    onClose={() => this.props.hide()}
                    animationType="slide-up"
                >
                    <div className='shareqrcode-container'>
                        <div className='sq-title'>立即分享给好友</div>
                        <div className='sq-content'>
                            <CopyToClipboard text={getShareUrl()} onCopy={() => Toast.success("已复制", 1)}>
                                <a>
                                    <span><Iconfont style={{ fontSize: '26px', color: '#fff', }} libname="ckicon" type="dashujukeshihuaico-" /></span>
                                复制链接
                               </a>
                            </CopyToClipboard>

                            <a onClick={() => {
                                this.setState({ visible: true })
                            }}>
                                <span><Iconfont style={{ fontSize: '26px', color: '#fff', }} libname="ckicon" type="haibao" /></span>
                                专属海报
                            </a>
                        </div>
                        <WhiteSpace className='qa-whitespace' size="sm" />
                        <div className='sq-btn' onClick={() => this.props.hide()}>
                            取消
                        </div>
                    </div>
                </Modal>

            </div>)
    }
}

const mapStateToPorps = state => {
    const loginByOauth = state.loginByOauth;
    return { loginByOauth };
};
export default connect(mapStateToPorps)(ShareQrcodeModal);




// WEBPACK FOOTER //
// ./src/containers/invitation-page/ShareQrcodeModal.jsx